import SmallHeadingComponent from "../../component/SmallHeadingComponent"
import TextField from "../../component/TextField"
import MoveContentToRight from "../../component/MoveContentToRight"
import Button from "../../component/Button"
import Card from "../../component/Card"
import CenterContents from "../../component/CenterContents"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import CheckBox from "../../component/CheckBox"
import { PasswordForgottenSpecification } from "pokal_api"
import {
    NAVIGATION_VIEW,
    NavigationPaths
} from "../../navigation/NavigationController"
import { showNotification } from "../../redux/Notification"
import { useAppDispatch } from "../../redux/store/hooks"

function PasswordForgottenView() {
    const dispatch = useAppDispatch()

    const emailState = useState<string>("")
    const [patient, setPatient] = useState<boolean>(false)

    function submit() {
        PasswordForgottenSpecification.request({
            mail: emailState[0],
            professional: !patient
        })
            .then(() =>
                showNotification(
                    dispatch,
                    "Mail versandt",
                    "Bitte überprüfen Sie Ihren Posteingang und das Spam-Postfach."
                )
            )
            .catch(() => {
                /**/
            })
    }

    function submitEnabled(): boolean {
        return emailState[0] !== ""
    }

    return (
        <CenterContents>
            <Card>
                <div className={"flex flex-col space-y-10"}>
                    <SmallHeadingComponent>
                        Passwort zurücksetzen
                    </SmallHeadingComponent>
                    <TextField
                        inputState={emailState}
                        type={"text"}
                        placeholder={"Emailadresse hier eingeben"}
                        label={"Emailadresse"}
                    />
                    <CheckBox initial={patient} onChange={(p) => setPatient(p)}>
                        Sie nutzen die Platform als Patient:in
                    </CheckBox>
                    <MoveContentToRight>
                        <Button disabled={!submitEnabled()} onClick={submit}>
                            Link anfordern
                        </Button>
                    </MoveContentToRight>
                </div>
            </Card>
        </CenterContents>
    )
}

export default PasswordForgottenView
